import { Navigate } from "react-router-dom";
import { ShieldCheck, Clock4, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const Wordmark = ({ light }) => (
  <div className="flex items-center gap-2" data-testid="brand-wordmark">
    <div className={`h-7 w-7 rounded-md grid place-items-center ${light ? "bg-white/10" : "bg-[#0B3C2D]"}`}>
      <span className="font-display font-extrabold text-white text-sm">1</span>
    </div>
    <div className="leading-tight">
      <div className={`font-display font-extrabold tracking-tight text-[15px] ${light ? "text-white" : "text-[#0B3C2D]"}`}>
        THAKKER ONE<span className="text-emerald-500">.</span>
      </div>
      <div className={`text-[10.5px] ${light ? "text-white/60" : "text-gray-500"}`}>Lead Engine & CRM</div>
    </div>
  </div>
);

export default function Login() {
  const { user, loading } = useAuth();
  if (!loading && user) return <Navigate to="/" replace />;
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F6F8F6]">
      <div className="hidden lg:flex flex-col justify-between bg-[#0B3C2D] p-12 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1589793463357-5fb813435467?crop=entropy&cs=srgb&fm=jpg&q=70&w=1400"
          alt="" className="absolute inset-0 h-full w-full object-cover opacity-[0.13] mix-blend-luminosity" />
        <div className="relative"><Wordmark light /></div>
        <div className="relative max-w-md">
          <p className="eyebrow !text-emerald-300/80 mb-4">Powered by Thakker Polypack</p>
          <h1 className="font-display text-4xl font-bold text-white leading-tight tracking-tight">
            Every enquiry, qualified.<br />Every lead, followed up.
          </h1>
          <div className="mt-10 space-y-4 text-sm text-white/75">
            {[[Clock4, "Five-day accountability on every pipeline stage"], [Sparkles, "AI-assisted qualification and email drafting"],
              [ShieldCheck, "Role-based access with full audit trail"]].map(([I, t]) => (
              <div key={t} className="flex items-center gap-3"><I className="h-4 w-4 text-emerald-300" />{t}</div>
            ))}
          </div>
        </div>
        <p className="relative text-xs text-white/40">© Thakker Polypack · Industrial flexible packaging</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm fade-in">
          <div className="lg:hidden mb-10"><Wordmark /></div>
          <h2 className="font-display text-2xl font-bold tracking-tight">Sign in</h2>
          <p className="text-sm text-gray-500 mt-1.5">Use your Thakker Polypack Google account to continue.</p>
          <Button data-testid="google-signin-button" onClick={signIn}
            className="w-full mt-8 h-11 bg-[#0B3C2D] hover:bg-[#072B20] rounded-lg text-sm font-medium">
            <svg className="h-4 w-4 mr-2" viewBox="0 0 24 24"><path fill="#fff" d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81z" /></svg>
            Continue with Google
          </Button>
          <p className="text-xs text-gray-400 mt-6 leading-relaxed">
            New team members get access after an administrator approves their account.
          </p>
        </div>
      </div>
    </div>
  );
}
